import { AlertSettingsApiFactory, V1FailureAlertSetting, V1LongStayAlertSetting, V1LowBatteryAlertSetting } from '@vacancorp/enterprise-for-client.vacanservice.com'
import { FailureAlertSetting, LongStayAlertSetting, LowBatteryAlertSetting } from '@/models'
import { api, ApiResponse, createApiError } from './base'

function createFailureAlertSetting(rawAlertSetting?: V1FailureAlertSetting): FailureAlertSetting | undefined {
  if (!rawAlertSetting) return undefined

  return new FailureAlertSetting({
    companyId: rawAlertSetting.companyId,
  })
}

function createLongStayAlertSetting(rawAlertSetting?: V1LongStayAlertSetting): LongStayAlertSetting | undefined {
  if (!rawAlertSetting) return undefined

  return new LongStayAlertSetting({
    companyId: rawAlertSetting.companyId,
    maxStayDurationSeconds: rawAlertSetting.maxStayDurationSeconds ? Number(rawAlertSetting.maxStayDurationSeconds) : undefined
  })
}

function createLowBatteryAlertSetting(rawAlertSetting?: V1LowBatteryAlertSetting): LowBatteryAlertSetting | undefined {
  if (!rawAlertSetting) return undefined

  return new LowBatteryAlertSetting({
    companyId: rawAlertSetting.companyId,
    threshold: rawAlertSetting.threshold,
  })
}

export const NewAlertSettingsApiFunc = () => {
  const webAdapter = AlertSettingsApiFactory(undefined, api.defaults.baseURL, api)

  // TODO: api側でページングしてくれるようになる予定なので、それに合わせて改修
  //       おそらくlistAlertSettings → adminListAlertSettingsになる
  return {
    getFailureAlertSetting: async (companyId: string, filter?: string): Promise<ApiResponse<FailureAlertSetting | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.getFailureAlertSetting(companyId, filter)
        data = createFailureAlertSetting(res.data)
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err,
      }
    },

    updateFailureAlertSetting: async (companyId: string, alertSetting: FailureAlertSetting): Promise<ApiResponse<FailureAlertSetting | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.updateFailureAlertSetting(companyId, {data: alertSetting})
        data = createFailureAlertSetting(res.data)
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err,
      }
    },

    getLongStayAlertSetting: async (companyId: string, filter?: string): Promise<ApiResponse<LongStayAlertSetting | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.getLongStayAlertSetting(companyId, filter)
        data = createLongStayAlertSetting(res.data)
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err,
      }
    },

    updateLongStayAlertSetting: async (companyId: string, alertSetting: LongStayAlertSetting): Promise<ApiResponse<LongStayAlertSetting | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.updateLongStayAlertSetting(companyId, {data: alertSetting})
        data = createLongStayAlertSetting(res.data)
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err,
      }
    },

    getLowBatteryAlertSetting: async (companyId: string, filter?: string): Promise<ApiResponse<LowBatteryAlertSetting | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.getLowBatteryAlertSetting(companyId, filter)
        data = createLowBatteryAlertSetting(res.data)
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err,
      }
    },

    updateLowBatteryAlertSetting: async (companyId: string, alertSetting: LowBatteryAlertSetting): Promise<ApiResponse<LowBatteryAlertSetting | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.updateLowBatteryAlertSetting(companyId, {data: alertSetting})
        data = createLowBatteryAlertSetting(res.data)
      } catch (e) {
        err = createApiError(e)
      }

      return {
        data,
        err,
      }
    }
  }
}